import { legacySelfCareHome } from '@hub/config/redirects';
import { env } from '@hub/config/runtime';
import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { getPriceBreakdownOptions, getSubscriptionOptions, getSummaryOptions } from '@platform/api';
import { HomePaths } from './route.paths';

export default function createHomeRoutes(parents: DomainParents) {
  const homeRoute = definePageRoute(parents, {
    path: HomePaths.home,
    title: m.home_page_title,
    page: () => import('./Home.page'),
    pendingComponent: () => import('./components/HomeSkeleton'),
    loader: ({ context }) => {
      context.queryClient.prefetchQuery(getSubscriptionOptions());
      context.queryClient.prefetchQuery(getPriceBreakdownOptions());
      context.queryClient.prefetchQuery(getSummaryOptions());
    },
    disableBreadcrumb: true,
    // Page renders its own `<Page>` with an auth-derived JSX greeting; the plain
    // `title` above still feeds the browser tab via `head.meta.title`.
    customLayout: true,
    flag: 'page-startpage',
    flagFallbackHref: legacySelfCareHome(env.waipuDomain),
  });

  return defineDomainRoutes({
    authenticated: [homeRoute] as const,
    public: [] as const,
  });
}
